var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_29986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71993 18H15.2799C16.5966 18 17.6666 16.93 17.6666 15.6133V3.71998C17.6666 2.40332 16.5966 1.33331 15.2799 1.33331H14.3333V0.666654C14.3333 0.299983 14.0332 0 13.6666 0C13.2999 0 12.9999 0.299983 12.9999 0.666654V1.33331H4.99994V0.666654C4.99994 0.299983 4.6999 0 4.33323 0C3.96656 0 3.66658 0.299983 3.66658 0.666654V1.33331H2.71993C1.40326 1.33331 0.333252 2.40332 0.333252 3.71998V15.6133C0.333252 16.93 1.40326 18 2.71993 18ZM1.66662 3.71998C1.66662 3.14 2.13994 2.66667 2.71993 2.66667H3.66658V3.33333C3.66658 3.7 3.96656 3.99998 4.33323 3.99998C4.6999 3.99998 4.99989 3.7 4.99989 3.33333V2.66667H12.9999V3.33333C12.9999 3.7 13.2999 3.99998 13.6666 3.99998C14.0332 3.99998 14.3332 3.7 14.3332 3.33333V2.66667H15.2799C15.8598 2.66667 16.3332 3.14 16.3332 3.71998V15.6133C16.3332 16.1933 15.8598 16.6666 15.2799 16.6666H2.71993C2.13994 16.6666 1.66662 16.1933 1.66662 15.6133V3.71998Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16657 7.66664C5.6268 7.66664 5.99989 7.29355 5.99989 6.83332C5.99989 6.37309 5.6268 6 5.16657 6C4.70634 6 4.33325 6.37309 4.33325 6.83332C4.33325 7.29355 4.70634 7.66664 5.16657 7.66664Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83332 7.66664C9.29355 7.66664 9.66664 7.29355 9.66664 6.83332C9.66664 6.37309 9.29355 6 8.83332 6C8.37309 6 8 6.37309 8 6.83332C8 7.29355 8.37309 7.66664 8.83332 7.66664Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 7.66664C12.9601 7.66664 13.3331 7.29355 13.3331 6.83332C13.3331 6.37309 12.9601 6 12.4998 6C12.0396 6 11.6665 6.37309 11.6665 6.83332C11.6665 7.29355 12.0396 7.66664 12.4998 7.66664Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16657 11.0001C5.6268 11.0001 5.99989 10.627 5.99989 10.1668C5.99989 9.70658 5.6268 9.3335 5.16657 9.3335C4.70634 9.3335 4.33325 9.70658 4.33325 10.1668C4.33325 10.627 4.70634 11.0001 5.16657 11.0001Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83332 11.0001C9.29355 11.0001 9.66664 10.627 9.66664 10.1668C9.66664 9.70658 9.29355 9.3335 8.83332 9.3335C8.37309 9.3335 8 9.70658 8 10.1668C8 10.627 8.37309 11.0001 8.83332 11.0001Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 11.0001C12.9601 11.0001 13.3331 10.627 13.3331 10.1668C13.3331 9.70658 12.9601 9.3335 12.4998 9.3335C12.0396 9.3335 11.6665 9.70658 11.6665 10.1668C11.6665 10.627 12.0396 11.0001 12.4998 11.0001Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16657 14.3331C5.6268 14.3331 5.99989 13.9601 5.99989 13.4998C5.99989 13.0396 5.6268 12.6665 5.16657 12.6665C4.70634 12.6665 4.33325 13.0396 4.33325 13.4998C4.33325 13.9601 4.70634 14.3331 5.16657 14.3331Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83332 14.3331C9.29355 14.3331 9.66664 13.9601 9.66664 13.4998C9.66664 13.0396 9.29355 12.6665 8.83332 12.6665C8.37309 12.6665 8 13.0396 8 13.4998C8 13.9601 8.37309 14.3331 8.83332 14.3331Z",
    fill: "#91BCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 14.3331C12.9601 14.3331 13.3331 13.9601 13.3331 13.4998C13.3331 13.0396 12.9601 12.6665 12.4998 12.6665C12.0396 12.6665 11.6665 13.0396 11.6665 13.4998C11.6665 13.9601 12.0396 14.3331 12.4998 14.3331Z",
    fill: "#91BCCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_29986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeCalendar);
export default __webpack_public_path__ + "static/media/icon-stroke-calendar.fb2e28a8f9f525e53b94f4f82395d773.svg";
export { ForwardRef as ReactComponent };